import { isURL } from '@agilepoint/utils-common';
import { messages } from './messages';

export function url(value: any, options?: { message: string; }) {
    if (isURL(value)) {
        return undefined;
    }

    return options && options.message ? options.message : messages.invalidURL;
}
